export const OnlineProvider = {
    youTube: "youTube",
    youTubeRecord: "youTubeRecord",
    custom: "custom",
    pastSessionRecord: "pastSessionRecord",
    zoom: "zoom",
    webConference: "webConference",
    agora: "agora",
    liveKit: "liveKit",
    empty: ""
} as const;

export type OnlineProvider = typeof OnlineProvider[keyof typeof OnlineProvider];